(function (window, $, app) {
    var Array = window.Array;
    var JSON = window.JSON;
    var document = window.document;
    
    function Tab() {
        var _this = this;
        
        var setContainerSizes = function () {
            $('.tab\\.container').each(function () {
                var $this = $(this);
                var $current = $this.find('.tab.\\--active');
                
                $this.height($current.height());
            });
        };
        
        this.bind = function () {
            app.$doc.ready(setContainerSizes);
            $(window).resize(setContainerSizes);
        };
        
        this.select = function (container, id) {
            var $container = $('#' + container);
            var $current = $container.find('.tab.\\--active');
            var $select = $('#' + id);
            var $navSelect = $('[href="#' + id + '"]').parent();
            var $nav = $navSelect.parent();
            var $navCurrent = $nav.find('.btn.\\--active');
            
            if ($current.attr('id') === id) {
                return false;
            }
            
            $current.removeClass('--active');
            $navCurrent.removeClass('--active');
            $select.addClass('--active');
            $navSelect.addClass('--active');
            
            $container.height($select.height());
        };
    }
    
    app.registerModule('Tab', new Tab());
})(window, jQuery, app);
